import type { RouteEntry } from '../types';

// ═══════════════════════════════════════════════════════════════════════════
// CROSS-CUTTING / SHARED
// ═══════════════════════════════════════════════════════════════════════════

// ── IFRS 17 Reference (appears in every functionality's nav) ──
const IFRS17_REFERENCE_ROUTES: RouteEntry[] = [
  {
    path: 'ifrs17-traceability',
    component: 'IFRS17TraceabilityPage',
    label: 'Traceability Matrix',
    allowedRoles: [
      'super_admin',
      'admin',
      'company_user',
      'consultant_user',
      'auditor',
      'regulator',
      'executive',
    ],
    navSection: 'IFRS 17 Reference',
    navIcon: 'MenuBook',
    // Shared across all functionalities
  },
];

// ═══════════════════════════════════════════════════════════════════════════
// COMPANY (sidebar bottom section)
// ═══════════════════════════════════════════════════════════════════════════
const COMPANY_ROUTES: RouteEntry[] = [
  {
    path: 'company-info',
    component: 'CompanyInfoPage',
    label: 'Company Info',
    allowedRoles: ['company_user', 'consultant_user', 'auditor', 'regulator', 'executive'],
    navSection: 'Company',
    hideFromNav: true,
    // In bottom pinned section, not per-functionality nav
  },
  {
    path: 'business-classes',
    component: 'BusinessClassesPage',
    label: 'Business Classes',
    allowedRoles: ['company_user', 'consultant_user', 'auditor', 'executive'],
    navSection: 'Company',
    hideFromNav: true,
  },
  {
    path: 'contract-groups',
    component: 'ContractGroupsPage',
    label: 'Contract Groups',
    allowedRoles: ['company_user', 'consultant_user', 'auditor'],
    navSection: 'Company',
    hideFromNav: true,
  },
  {
    path: 'ifrs17-policies',
    component: 'IFRS17PoliciesPage',
    label: 'IFRS 17 Policies',
    allowedRoles: ['company_user', 'consultant_user', 'auditor'],
    navSection: 'Company',
    hideFromNav: true,
  },
];

// ═══════════════════════════════════════════════════════════════════════════
// COMMUNITY (sidebar bottom section)
// ═══════════════════════════════════════════════════════════════════════════
const COMMUNITY_ROUTES: RouteEntry[] = [
  {
    path: 'profile',
    component: 'MyProfilePage',
    label: 'My Profile',
    allowedRoles: [], // all authenticated
    navSection: 'Community',
    hideFromNav: true,
  },
  {
    path: 'profile/:userId',
    component: 'UserProfilePage',
    label: '',
    allowedRoles: [], // all authenticated
    hideFromNav: true,
  },
  {
    path: 'directory',
    component: 'DirectoryPage',
    label: 'Directory',
    allowedRoles: [], // all authenticated
    navSection: 'Community',
    hideFromNav: true,
  },
  {
    path: 'messages',
    component: 'MessagesPage',
    label: 'Messages',
    allowedRoles: ['company_user', 'consultant_user', 'auditor', 'executive'],
    navSection: 'Community',
    hideFromNav: true,
  },
];

// ═══════════════════════════════════════════════════════════════════════════
// HELP (sidebar bottom section)
// ═══════════════════════════════════════════════════════════════════════════
const HELP_ROUTES: RouteEntry[] = [
  {
    path: 'glossary',
    component: 'GlossaryPage',
    label: 'Glossary',
    allowedRoles: [], // all authenticated
    navSection: 'Help',
    hideFromNav: true,
  },
];

export const SYSTEM_ROUTES: RouteEntry[] = [
  ...IFRS17_REFERENCE_ROUTES,
  ...COMPANY_ROUTES,
  ...COMMUNITY_ROUTES,
  ...HELP_ROUTES,
];
